import React, { useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import DatePicker from "react-datepicker";

import { hideModal } from '../../actions/modal/modal';
import { toggleSightingLayer, koalaItemClick } from '../../actions/mainview/mainview';

const SightingFiltering = props => {

  const dispatch = useDispatch(),
        mainviewProps = useSelector(store => store.mainview),
        map = props.map,
        [filterDate, setFilterDate] = useState(null),
        [status, setStatus] = useState(null),
        [withJoey, setWithJoey] = useState(null),
        selectRef = useRef(null);

  const isNull = val => val === null || val === 'null';
  
  const _setFilter = () => {

    if (!mainviewProps.showSightingLayer) dispatch(toggleSightingLayer(true));

    map.setFilter('sightings_layer', null);

    const isWithJoey = withJoey === 'true' ? true : withJoey === 'false' ? false : null; // Converting string booleans to proper
    
    let sightingsFilter = null;

    if (isNull(status) && isNull(filterDate) && isNull(isWithJoey)) sightingsFilter = null; // Both empty
    else if (status && isNull(filterDate) && isNull(isWithJoey)) sightingsFilter = ['all', ['==', 'status', status]]; // Only status populated
    else if (filterDate && isNull(status) && isNull(isWithJoey)) sightingsFilter = ['all', ['>=', 'datetime_of_sighting', filterDate.toLocaleDateString('fr-CA')]]; // Only data populated
    else if (isWithJoey && isNull(filterDate) && isNull(status)) sightingsFilter = ['all', ['==', 'with_joey', isWithJoey]];
    else if (isWithJoey && status && isNull(filterDate)) { // Only with joey & has a status
      sightingsFilter = ['all', ['==', 'status', status], ['==', 'with_joey', isWithJoey]];
    }
    else if (isWithJoey && filterDate && isNull(status)) { // Only with joey and a date filter
      sightingsFilter = ['all', ['>=', 'datetime_of_sighting', filterDate.toLocaleDateString('fr-CA')], ['==', 'with_joey', isWithJoey]];
    }
    else if (filterDate && status && isNull(isWithJoey)) { // Only with a status and date filter
      sightingsFilter = ['all', ['==', 'status', status], ['>=', 'datetime_of_sighting', filterDate.toLocaleDateString('fr-CA')]];
    }
    else { // All populated
      sightingsFilter = ['all', ['==', 'with_joey', isWithJoey], ['==', 'status', status], ['>=', 'datetime_of_sighting', filterDate.toLocaleDateString('fr-CA')]];
    }
        
    map.setFilter('sightings_layer', sightingsFilter);

    dispatch(hideModal());
    dispatch(koalaItemClick(false));
  }

  const _removeFilter = () => {
    map.setFilter('sightings_layer', null);
    setFilterDate(null);
    setStatus(null);

    selectRef.current.value = 'null';
  }
  
  return (
    <>
      <span className="modal__close" onClick={ () => dispatch(hideModal()) }>&times;</span>
      
      <h3 className="modal__header">Koala Sightings</h3>

      <div className="form form--restricted">
        <p className="form__text" style={{ fontSize: '.8rem' }}>Select an option below to filter the sightings on the map. Alternatively, you can leave them as default to see all sightings.</p>
        
        <div className="form__group form__group--horizontal">
          <fieldset className="form__item-container">
            <div className="form__group">
              <label htmlFor="status" className="form__label" style={{ textAlign: 'left' }}>Koala status</label>
              <div className="form__select-container" onChange={ e => setStatus(e.target.value) }>
                <select className="form__select" id="status" name="status" ref={ selectRef }>
                  <option value="null">Any</option>
                  <option value="Healthy">Healthy</option>
                  <option value="Sick/Injured">Sick/Injured</option>
                  <option value="Deceased">Deceased</option>
                </select>
              </div>
            </div>
          </fieldset>
          <fieldset className="form__item-container">
            <div className="form__group">
              <label htmlFor="withJoey" className="form__label" style={{ textAlign: 'left' }}>With Joey?</label>
              <div className="form__select-container">
                <select className="form__select" id="withJoey" name="withJoey" onChange={ e => setWithJoey(e.target.value) } >
                  <option value="null">Any</option>
                  <option value="true">Yes</option>
                  <option value="false">No</option>
                </select>
              </div>
            </div>
          </fieldset>
        </div>
      
        <div className="form__group">
          <label htmlFor="datetime_of_sighting" className="form__label">View sightings from</label>
          <DatePicker
            selected={ filterDate }
            className="form__input"
            placeholderText="Click to set a date filter, or leave blank for default"
            name="datetime_of_sighting"
            showMonthDropdown
            showYearDropdown
            dropdownMode="select"
            id="datetime_of_sighting"
            isClearable
            dateFormat="yyyy-MM-dd"
            onChange={ date => setFilterDate(date) } />
        </div>

        <div className="form__button-group">
          <span className="form__button button button--hollow" onClick={ () => _removeFilter() }>Remove filters</span>
          <button type="submit" className="form__button button" onClick={ () => _setFilter() }>View sightings</button>
        </div>
      </div>
    </>
  );

}

export default SightingFiltering;